export default __webpack_public_path__ + "f3c189546ba25f47e8165314d4b45ddb.wav";